import { useState } from "react";
import InputField from "./inputField.js";
import { useNavigate } from "react-router-dom";

export default function LoginForm({ setSupportMessage }) {
  const navigate = useNavigate();
  const [usuario, setUsuario] = useState("");
  const [clave, setClave] = useState("");


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ usuario, clave }),
      });

      const text = await response.text();
      //console.log("=== RESPUESTA CRUDA DEL SERVIDOR ===");
      //console.log(text);
      //console.log("Status:", response.status, response.statusText);

      if (!text || text.trim() === "") {
        setSupportMessage("El servidor no devolvió ninguna respuesta (posible error PHP)");
        return;
      }

      let data;
      try {
        data = JSON.parse(text);
      } catch (jsonError) {
        //console.error("Error al parsear JSON:", jsonError);
        setSupportMessage("Error: El servidor devolvió una respuesta inválida (no es JSON)");
        return;
      }

      if (!response.ok || data.success === false) {
        setSupportMessage(data.message || data.error || "Usuario o Clave incorrectos");
        return;
      }

      // Login exitoso
      localStorage.setItem("databaseName", data.client_db);
      localStorage.setItem("userName", "ga" + data.client_id);
      localStorage.setItem("clientName", data.client_name);

      navigate("/menu");

    } catch (error) {
      console.error("Error en fetch:", error);
      setSupportMessage("No se pudo conectar con el servidor.");
    }
  };

  return (

    <form className="login-form" onSubmit={handleSubmit} autoComplete="off">
      <InputField
        type="text"
        placeholder="Usuario"
        icon="user"
        value={usuario}
        onChange={(e) => setUsuario(e.target.value)}
        autoComplete = "new-user"
      />
      <InputField
        type="password"
        placeholder="Clave"
        icon="lock"
        value={clave}
        onChange={(e) => setClave(e.target.value)}
        autoComplete = "new-password"
      />
      <button type="submit" className="login-button">Ingresar</button>
    </form>

  );
}
